import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76c27159"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-container" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "url" }, "URL", -1))
const _hoisted_4 = { class: "p-inputgroup" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-link" })
], -1))
const _hoisted_6 = {
  key: 0,
  class: "p-error font-light"
}
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Description", -1))
const _hoisted_9 = {
  key: 0,
  class: "p-error font-light"
}
const _hoisted_10 = { class: "field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "tags" }, "Tags"),
  /*#__PURE__*/_createElementVNode("small", null, "Add up to 5 tags to describe what your post is about")
], -1))

import { reactive } from "vue";
import useVuelidate from "@vuelidate/core";
import { required, maxLength, url } from "@vuelidate/validators";
import { escapeHtml } from "@/filters/escapeHtmlFilter";
import SearchChips from "@/components/search/SearchChips.vue"


export default /*#__PURE__*/_defineComponent({
  props: {
    loading: { type: Boolean }
  },
  emits: ["post-click"],
  setup(__props: any, { emit }) {





const state = reactive({
  url: null,
  description: null,
  tags: Array<string>(),
});

const rules = {
  url: { required, url },
  description: { maxLength: maxLength(1000) },
  tags: { maxLength: maxLength(5) }
};

const v$ = useVuelidate(rules, state);

const submit = () => {
  v$.value.$validate();

  if (!v$.value.$error) {
    emit("post-click", {
      ...state,
      description: escapeHtml(state.description!).value,
    });
  }
};

const onChipsUpdate = (chips: string[]) => {
  state.tags = chips
}

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { class: "p-0" }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_InputText, {
              id: "url",
              modelValue: _unref(state).url,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).url) = $event)),
              placeholder: "https://www.your-url.com/",
              class: _normalizeClass({ 'p-invalid': _unref(v$).url.$error }),
              "data-test": "url"
            }, null, 8, ["modelValue", "class"])
          ]),
          (_unref(v$).url.$error)
            ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_unref(v$).url.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_TextArea, {
            autoResize: true,
            rows: "7",
            id: "description",
            modelValue: _unref(state).description,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).description) = $event)),
            class: "w-full"
          }, null, 8, ["modelValue"]),
          (_unref(v$).description.$error)
            ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_unref(v$).description.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(SearchChips, {
            onUpdate: _cache[2] || (_cache[2] = ($event: any) => (onChipsUpdate($event)))
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_Button, {
            label: "Post",
            loading: __props.loading,
            onClick: submit,
            "data-test": "submit"
          }, null, 8, ["loading"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})